import { render, staticRenderFns } from "./clientes-envio-documento.vue?vue&type=template&id=3c4efbdb"
import script from "./clientes-envio-documento.vue?vue&type=script&lang=js"
export * from "./clientes-envio-documento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports